import { NewsArticle, NewsCategory, NewsProvider, UserLocation } from '../types/news';

// News API configuration
const NEWS_API_KEY = 'd82e4c4ce5aa45a788dd74107cea1bd7'; // Replace with actual API key
const NEWS_API_BASE_URL = 'https://newsapi.org/v2';

// Popular news providers by country and category
const NEWS_PROVIDERS: NewsProvider[] = [
  // Indian News Sources
  { id: 'the-times-of-india', name: 'The Times of India', domain: 'timesofindia.indiatimes.com', country: 'in', category: 'general', language: 'en', priority: 1 },
  { id: 'the-hindu', name: 'The Hindu', domain: 'thehindu.com', country: 'in', category: 'general', language: 'en', priority: 1 },
  { id: 'economic-times', name: 'Economic Times', domain: 'economictimes.indiatimes.com', country: 'in', category: 'business', language: 'en', priority: 1 },
  { id: 'ndtv', name: 'NDTV', domain: 'ndtv.com', country: 'in', category: 'general', language: 'en', priority: 1 },
  { id: 'india-today', name: 'India Today', domain: 'indiatoday.in', country: 'in', category: 'general', language: 'en', priority: 1 },
  
  // International News Sources
  { id: 'bbc-news', name: 'BBC News', domain: 'bbc.com', country: 'gb', category: 'general', language: 'en', priority: 2 },
  { id: 'cnn', name: 'CNN', domain: 'cnn.com', country: 'us', category: 'general', language: 'en', priority: 2 },
  { id: 'reuters', name: 'Reuters', domain: 'reuters.com', country: 'us', category: 'general', language: 'en', priority: 2 },
  { id: 'techcrunch', name: 'TechCrunch', domain: 'techcrunch.com', country: 'us', category: 'technology', language: 'en', priority: 2 },
  { id: 'bloomberg', name: 'Bloomberg', domain: 'bloomberg.com', country: 'us', category: 'business', language: 'en', priority: 2 },
];

// Mock news data for demonstration (replace with actual API calls)
const generateMockNews = (category?: NewsCategory, country?: string): NewsArticle[] => {
  const mockArticles: NewsArticle[] = [
    {
      id: '1',
      title: 'Indian Stock Market Reaches New Heights Amid Economic Recovery',
      description: 'The Indian stock market continues its upward trajectory as economic indicators show strong recovery signs.',
      content: 'The Indian stock market has been performing exceptionally well...',
      url: 'https://example.com/news/1',
      urlToImage: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&q=80&w=800',
      publishedAt: new Date().toISOString(),
      source: { id: 'economic-times', name: 'Economic Times' },
      author: 'Financial Reporter',
      category: 'business',
      country: 'in',
      language: 'en'
    },
    {
      id: '2',
      title: 'Technology Sector Shows Strong Growth in Q4',
      description: 'Major technology companies report impressive quarterly results driving sector growth.',
      content: 'The technology sector has shown remarkable resilience...',
      url: 'https://example.com/news/2',
      urlToImage: 'https://images.unsplash.com/photo-1518186285589-2f7649de83e0?auto=format&fit=crop&q=80&w=800',
      publishedAt: new Date(Date.now() - 3600000).toISOString(),
      source: { id: 'techcrunch', name: 'TechCrunch' },
      author: 'Tech Reporter',
      category: 'technology',
      country: 'us',
      language: 'en'
    },
    {
      id: '3',
      title: 'Healthcare Innovations Transform Patient Care in India',
      description: 'New healthcare technologies are revolutionizing patient care across Indian hospitals.',
      content: 'Healthcare innovations are making significant impact...',
      url: 'https://example.com/news/3',
      urlToImage: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?auto=format&fit=crop&q=80&w=800',
      publishedAt: new Date(Date.now() - 7200000).toISOString(),
      source: { id: 'the-hindu', name: 'The Hindu' },
      author: 'Health Reporter',
      category: 'health',
      country: 'in',
      language: 'en'
    },
    {
      id: '4',
      title: 'Political Developments Shape Economic Policy',
      description: 'Recent political decisions are expected to have significant impact on economic policies.',
      content: 'Political developments continue to influence...',
      url: 'https://example.com/news/4',
      urlToImage: 'https://images.unsplash.com/photo-1586339949916-3e9457bef6d3?auto=format&fit=crop&q=80&w=800',
      publishedAt: new Date(Date.now() - 10800000).toISOString(),
      source: { id: 'ndtv', name: 'NDTV' },
      author: 'Political Correspondent',
      category: 'politics',
      country: 'in',
      language: 'en'
    },
    {
      id: '5',
      title: 'Bengaluru Infrastructure Development Updates',
      description: 'Major infrastructure projects in Bengaluru are progressing as planned with new metro lines.',
      content: 'Bengaluru continues to expand its infrastructure...',
      url: 'https://example.com/news/5',
      urlToImage: 'https://images.unsplash.com/photo-1570939274717-7eda259b50ed?auto=format&fit=crop&q=80&w=800',
      publishedAt: new Date(Date.now() - 14400000).toISOString(),
      source: { id: 'the-times-of-india', name: 'The Times of India' },
      author: 'City Reporter',
      category: 'local',
      country: 'in',
      language: 'en'
    },
    {
      id: '6',
      title: 'Global Markets React to Federal Reserve Decision',
      description: 'International markets show mixed reactions to the latest Federal Reserve policy announcement.',
      content: 'Global financial markets are responding...',
      url: 'https://example.com/news/6',
      urlToImage: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&q=80&w=800',
      publishedAt: new Date(Date.now() - 18000000).toISOString(),
      source: { id: 'bloomberg', name: 'Bloomberg' },
      author: 'Market Analyst',
      category: 'business',
      country: 'us',
      language: 'en'
    }
  ];

  let filtered = mockArticles;

  if (category) {
    filtered = filtered.filter(article => article.category === category);
  }

  if (country) {
    filtered = filtered.filter(article => article.country === country);
  }

  return filtered;
};

export async function fetchNews(
  category?: NewsCategory,
  country?: string,
  sources?: string[]
): Promise<NewsArticle[]> {
  try {
    // In a real implementation, you would use the News API
    const url = new URL(`${NEWS_API_BASE_URL}/top-headlines`);
    if (category) url.searchParams.append('category', category);
    if (country) url.searchParams.append('country', country);
    if (sources) url.searchParams.append('sources', sources.join(','));
    url.searchParams.append('apiKey', NEWS_API_KEY);
    
    const response = await fetch(url.toString());
    if (!response.ok) throw new Error('Failed to fetch news');
    const data = await response.json();
    return data;
    
    // For demo purposes, return mock data
    // await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API delay
    // return generateMockNews(category, country);
  } catch (error) {
    console.error('Error fetching news:', error);
    return generateMockNews(category, country);
  }
}

export async function fetchNewsByCategory(category: NewsCategory): Promise<NewsArticle[]> {
  return fetchNews(category);
}

export async function fetchLocalNews(location: UserLocation): Promise<NewsArticle[]> {
  try {
    // Fetch local news based on user location
    const localNews = generateMockNews('local', location.countryCode);
    return localNews;
  } catch (error) {
    console.error('Error fetching local news:', error);
    return [];
  }
}

export async function searchNews(query: string): Promise<NewsArticle[]> {
  try {
    // In a real implementation:
    const url = new URL(`${NEWS_API_BASE_URL}/everything`);
    url.searchParams.append('q', query);
    url.searchParams.append('apiKey', NEWS_API_KEY);
    
    // For demo, filter mock data
    const allNews = generateMockNews();
    return allNews.filter(article => 
      article.title.toLowerCase().includes(query.toLowerCase()) ||
      article.description.toLowerCase().includes(query.toLowerCase())
    );
  } catch (error) {
    console.error('Error searching news:', error);
    return [];
  }
}

export async function getUserLocation(): Promise<UserLocation | null> {
  try {
    // Try to get user's current position
    const position = await new Promise<GeolocationPosition>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        timeout: 10000,
        enableHighAccuracy: true
      });
    });

    // Use IP-based location service as fallback
    const response = await fetch('https://ipapi.co/json/');
    const locationData = await response.json();

    return {
      country: locationData.country_name || 'India',
      countryCode: locationData.country_code || 'IN',
      region: locationData.region || 'Karnataka',
      city: locationData.city || 'Bengaluru',
      latitude: position.coords.latitude || locationData.latitude || 12.9716,
      longitude: position.coords.longitude || locationData.longitude || 77.5946,
      timezone: locationData.timezone || 'Asia/Kolkata',
      lastUpdated: new Date().toISOString()
    };
  } catch (error) {
    console.error('Error getting user location:', error);
    // Return default location (Bengaluru, India)
    return {
      country: 'India',
      countryCode: 'IN',
      region: 'Karnataka',
      city: 'Bengaluru',
      latitude: 12.9716,
      longitude: 77.5946,
      timezone: 'Asia/Kolkata',
      lastUpdated: new Date().toISOString()
    };
  }
}

export function getNewsProviders(): NewsProvider[] {
  return NEWS_PROVIDERS;
}

export function getNewsCategoriesWithLabels() {
  return [
    { value: 'general', label: 'General' },
    { value: 'business', label: 'Business' },
    { value: 'technology', label: 'Technology' },
    { value: 'health', label: 'Health' },
    { value: 'science', label: 'Science' },
    { value: 'sports', label: 'Sports' },
    { value: 'entertainment', label: 'Entertainment' },
    { value: 'politics', label: 'Politics' },
    { value: 'local', label: 'Local News' }
  ];
}